import React, { Component } from 'react';
import {
  shape,
  string,
  func,
  bool,
} from 'prop-types';
import Password from './PasswordPresentation';
import passwordStrength from './../../../../utilities/passwordStrength';

class PasswordContainer extends Component {
  constructor(props) {
    super(props);

    this.showHidePassword = this.showHidePassword.bind(this);
    this.updateInputValue = this.updateInputValue.bind(this);

    const { input } = this.props;
    this.origOnChange = input.onChange;
    input.onChange = this.updateInputValue;

    this.state = {
      inputType: this.props.type,
      input,
    };
  }

  showHidePassword() {
    this.setState({
      inputType: this.state.inputType === 'text' ? 'password' : 'text',
    });
  }

  updateInputValue(event) {
    if (this.origOnChange) {
      this.origOnChange(event);
    }

    if (this.state.input.value !== event.target.value) {
      this.setState({
        input: {
          ...this.state.input,
          value: event.target.value,
        },
      });
    }
  }

  render() {
    const strength = passwordStrength(this.state.input.value || '');

    return (
      <Password
        input={this.state.input}
        dataTestId={this.props.dataTestId}
        label={this.props.label}
        inputType={this.state.inputType}
        showHidePassword={this.showHidePassword}
        forgotPasswordPath={this.props.forgotPasswordPath}
        meta={this.props.meta}
        message={strength.message.text}
        criteriaList={strength.criteriaList}
        messageColor={strength.message.color}
        showRequirements={this.props.showRequirements}
        strength={strength.strength}
      />
    );
  }
}

PasswordContainer.defaultProps = {
  forgotPasswordPath: '',
  dataTestId: '',
  showRequirements: false,
};

PasswordContainer.propTypes = {
  input: shape({ value: string, onChange: func }).isRequired,
  dataTestId: string,
  label: string.isRequired,
  type: string.isRequired,
  forgotPasswordPath: string,
  meta: shape({}).isRequired,
  showRequirements: bool,
};

export default PasswordContainer;
